import React, { Component } from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import AwesomeSliderStyles from 'react-awesome-slider/src/styled/fold-out-animation/fold-out-animation.scss';
import { Container } from 'shards-react';
export default class HelpPage extends Component {
  render() {
    return (
      <Container fluid className='p-3 mx-auto'>
        <h5 className='text-capitalize'>Help Page</h5>
        <AwesomeSlider
          cssModule={AwesomeSliderStyles}
          className='aws-btn'
          bullets={false}
        >
          <div
            data-src={require('../../../assets/img/slides/slide1.jpg')}
            className='img-fluid'
          />
          <div
            data-src={require('../../../assets/img/slides/slide2.jpg')}
            className='img-fluid'
          />
          <div
            data-src={require('../../../assets/img/slides/slide3.jpg')}
            className='img-fluid'
          />
          <div
            data-src={require('../../../assets/img/slides/slide4.jpg')}
            className='img-fluid'
          />
          <div
            data-src={require('../../../assets/img/slides/slide5.jpg')}
            className='img-fluid'
          />
          <div
            data-src={require('../../../assets/img/slides/slide6.jpg')}
            className='img-fluid'
          />
        </AwesomeSlider>
        <div className='mt-2'>
          <div>
            <strong>How to update your profile?</strong>
            <p>
              Click on Profile button on the sidebar. Fill in your details and
              click Update Profile.
            </p>
          </div>
          <div>
            <strong>How to add a new complaint?</strong>
            <p>
              Go to the Dashboard Page and Click the Add button. Fill in the
              complaint form and Click Submit. That's it. You are done!
            </p>
          </div>
          <div>
            <strong>How to check the complaint details?</strong>
            <p>
              Go to the Dashboard Page. Click on the arrow button on the
              complaint item under the Action column. This will lead to the
              Complaint Details page. Here you will be able to view the
              complaint details such as agent who has been assigned, emails from
              agent and emails that you sent.
            </p>
          </div>
        </div>
      </Container>
    );
  }
}
